export const COUNTRIES = {
    TWN: {
        official_name_en: '',
        iso3166alpha2: 'TW',
        iso3166alpha3: 'TWN',
        cldr_display_name: 'Taiwan',
        capital: 'Taipei',
        continent: 'AS',
        dial: '886',
        geoname_id: '1668284',
        global_code: '',
        global_name: '',
        region_code: '',
        region_name: '',
        subregion_code: '',
        subregion_name: '',
        is_independent: 'Yes'
    },
    AFG: {
        official_name_en: 'Afghanistan',
        iso3166alpha2: 'AF',
        iso3166alpha3: 'AFG',
        cldr_display_name: 'Afghanistan',
        capital: 'Kabul',
        continent: 'AS',
        dial: '93',
        geoname_id: '1149361',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '34',
        subregion_name: 'Southern Asia',
        is_independent: 'Yes'
    },
    ALB: {
        official_name_en: 'Albania',
        iso3166alpha2: 'AL',
        iso3166alpha3: 'ALB',
        cldr_display_name: 'Albania',
        capital: 'Tirana',
        continent: 'EU',
        dial: '355',
        geoname_id: '783754',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '39',
        subregion_name: 'Southern Europe',
        is_independent: 'Yes'
    },
    DZA: {
        official_name_en: 'Algeria',
        iso3166alpha2: 'DZ',
        iso3166alpha3: 'DZA',
        cldr_display_name: 'Algeria',
        capital: 'Algiers',
        continent: 'AF',
        dial: '213',
        geoname_id: '2589581',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '15',
        subregion_name: 'Northern Africa',
        is_independent: 'Yes'
    },
    ASM: {
        official_name_en: 'American Samoa',
        iso3166alpha2: 'AS',
        iso3166alpha3: 'ASM',
        cldr_display_name: 'American Samoa',
        capital: 'Pago Pago',
        continent: 'OC',
        dial: '1-684',
        geoname_id: '5880801',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '61',
        subregion_name: 'Polynesia',
        is_independent: 'Territory of US'
    },
    AND: {
        official_name_en: 'Andorra',
        iso3166alpha2: 'AD',
        iso3166alpha3: 'AND',
        cldr_display_name: 'Andorra',
        capital: 'Andorra la Vella',
        continent: 'EU',
        dial: '376',
        geoname_id: '3041565',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '39',
        subregion_name: 'Southern Europe',
        is_independent: 'Yes'
    },
    AGO: {
        official_name_en: 'Angola',
        iso3166alpha2: 'AO',
        iso3166alpha3: 'AGO',
        cldr_display_name: 'Angola',
        capital: 'Luanda',
        continent: 'AF',
        dial: '244',
        geoname_id: '3351879',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    AIA: {
        official_name_en: 'Anguilla',
        iso3166alpha2: 'AI',
        iso3166alpha3: 'AIA',
        cldr_display_name: 'Anguilla',
        capital: 'The Valley',
        continent: 'NA',
        dial: '1-264',
        geoname_id: '3573511',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Territory of GB'
    },
    ATA: {
        official_name_en: 'Antarctica',
        iso3166alpha2: 'AQ',
        iso3166alpha3: 'ATA',
        cldr_display_name: 'Antarctica',
        capital: '',
        continent: 'AN',
        dial: '672',
        geoname_id: '6697173',
        global_code: 'True',
        global_name: 'World',
        region_code: '',
        region_name: '',
        subregion_code: '',
        subregion_name: '',
        is_independent: 'International'
    },
    ATG: {
        official_name_en: 'Antigua and Barbuda',
        iso3166alpha2: 'AG',
        iso3166alpha3: 'ATG',
        cldr_display_name: 'Antigua & Barbuda',
        capital: "St. John's",
        continent: 'NA',
        dial: '1-268',
        geoname_id: '3576396',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    ARG: {
        official_name_en: 'Argentina',
        iso3166alpha2: 'AR',
        iso3166alpha3: 'ARG',
        cldr_display_name: 'Argentina',
        capital: 'Buenos Aires',
        continent: 'SA',
        dial: '54',
        geoname_id: '3865483',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    ARM: {
        official_name_en: 'Armenia',
        iso3166alpha2: 'AM',
        iso3166alpha3: 'ARM',
        cldr_display_name: 'Armenia',
        capital: 'Yerevan',
        continent: 'AS',
        dial: '374',
        geoname_id: '174982',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '145',
        subregion_name: 'Western Asia',
        is_independent: 'Yes'
    },
    ABW: {
        official_name_en: 'Aruba',
        iso3166alpha2: 'AW',
        iso3166alpha3: 'ABW',
        cldr_display_name: 'Aruba',
        capital: 'Oranjestad',
        continent: 'NA',
        dial: '297',
        geoname_id: '3577279',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Part of NL'
    },
    AUS: {
        official_name_en: 'Australia',
        iso3166alpha2: 'AU',
        iso3166alpha3: 'AUS',
        cldr_display_name: 'Australia',
        capital: 'Canberra',
        continent: 'OC',
        dial: '61',
        geoname_id: '2077456',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '53',
        subregion_name: 'Australia and New Zealand',
        is_independent: 'Yes'
    },
    AUT: {
        official_name_en: 'Austria',
        iso3166alpha2: 'AT',
        iso3166alpha3: 'AUT',
        cldr_display_name: 'Austria',
        capital: 'Vienna',
        continent: 'EU',
        dial: '43',
        geoname_id: '2782113',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '155',
        subregion_name: 'Western Europe',
        is_independent: 'Yes'
    },
    AZE: {
        official_name_en: 'Azerbaijan',
        iso3166alpha2: 'AZ',
        iso3166alpha3: 'AZE',
        cldr_display_name: 'Azerbaijan',
        capital: 'Baku',
        continent: 'AS',
        dial: '994',
        geoname_id: '587116',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '145',
        subregion_name: 'Western Asia',
        is_independent: 'Yes'
    },
    BHS: {
        official_name_en: 'Bahamas',
        iso3166alpha2: 'BS',
        iso3166alpha3: 'BHS',
        cldr_display_name: 'Bahamas',
        capital: 'Nassau',
        continent: 'NA',
        dial: '1-242',
        geoname_id: '3572887',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    BHR: {
        official_name_en: 'Bahrain',
        iso3166alpha2: 'BH',
        iso3166alpha3: 'BHR',
        cldr_display_name: 'Bahrain',
        capital: 'Manama',
        continent: 'AS',
        dial: '973',
        geoname_id: '290291',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '145',
        subregion_name: 'Western Asia',
        is_independent: 'Yes'
    },
    BGD: {
        official_name_en: 'Bangladesh',
        iso3166alpha2: 'BD',
        iso3166alpha3: 'BGD',
        cldr_display_name: 'Bangladesh',
        capital: 'Dhaka',
        continent: 'AS',
        dial: '880',
        geoname_id: '1210997',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '34',
        subregion_name: 'Southern Asia',
        is_independent: 'Yes'
    },
    BRB: {
        official_name_en: 'Barbados',
        iso3166alpha2: 'BB',
        iso3166alpha3: 'BRB',
        cldr_display_name: 'Barbados',
        capital: 'Bridgetown',
        continent: 'NA',
        dial: '1-246',
        geoname_id: '3374084',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    BLR: {
        official_name_en: 'Belarus',
        iso3166alpha2: 'BY',
        iso3166alpha3: 'BLR',
        cldr_display_name: 'Belarus',
        capital: 'Minsk',
        continent: 'EU',
        dial: '375',
        geoname_id: '630336',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '151',
        subregion_name: 'Eastern Europe',
        is_independent: 'Yes'
    },
    BEL: {
        official_name_en: 'Belgium',
        iso3166alpha2: 'BE',
        iso3166alpha3: 'BEL',
        cldr_display_name: 'Belgium',
        capital: 'Brussels',
        continent: 'EU',
        dial: '32',
        geoname_id: '2802361',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '155',
        subregion_name: 'Western Europe',
        is_independent: 'Yes'
    },
    BLZ: {
        official_name_en: 'Belize',
        iso3166alpha2: 'BZ',
        iso3166alpha3: 'BLZ',
        cldr_display_name: 'Belize',
        capital: 'Belmopan',
        continent: 'NA',
        dial: '501',
        geoname_id: '3582678',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    BEN: {
        official_name_en: 'Benin',
        iso3166alpha2: 'BJ',
        iso3166alpha3: 'BEN',
        cldr_display_name: 'Benin',
        capital: 'Porto-Novo',
        continent: 'AF',
        dial: '229',
        geoname_id: '2395170',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    BMU: {
        official_name_en: 'Bermuda',
        iso3166alpha2: 'BM',
        iso3166alpha3: 'BMU',
        cldr_display_name: 'Bermuda',
        capital: 'Hamilton',
        continent: 'NA',
        dial: '1-441',
        geoname_id: '3573345',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '21',
        subregion_name: 'Northern America',
        is_independent: 'Territory of GB'
    },
    BTN: {
        official_name_en: 'Bhutan',
        iso3166alpha2: 'BT',
        iso3166alpha3: 'BTN',
        cldr_display_name: 'Bhutan',
        capital: 'Thimphu',
        continent: 'AS',
        dial: '975',
        geoname_id: '1252634',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '34',
        subregion_name: 'Southern Asia',
        is_independent: 'Yes'
    },
    BOL: {
        official_name_en: 'Bolivia (Plurinational State of)',
        iso3166alpha2: 'BO',
        iso3166alpha3: 'BOL',
        cldr_display_name: 'Bolivia',
        capital: 'Sucre',
        continent: 'SA',
        dial: '591',
        geoname_id: '3923057',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    BES: {
        official_name_en: 'Bonaire, Sint Eustatius and Saba',
        iso3166alpha2: 'BQ',
        iso3166alpha3: 'BES',
        cldr_display_name: 'Caribbean Netherlands',
        oldCountryName: 'Netherlands Antilles',
        capital: '',
        continent: 'NA',
        dial: '599',
        geoname_id: '7626844',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Part of NL'
    },
    BIH: {
        official_name_en: 'Bosnia and Herzegovina',
        iso3166alpha2: 'BA',
        iso3166alpha3: 'BIH',
        cldr_display_name: 'Bosnia',
        capital: 'Sarajevo',
        continent: 'EU',
        dial: '387',
        geoname_id: '3277605',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '39',
        subregion_name: 'Southern Europe',
        is_independent: 'Yes'
    },
    BWA: {
        official_name_en: 'Botswana',
        iso3166alpha2: 'BW',
        iso3166alpha3: 'BWA',
        cldr_display_name: 'Botswana',
        capital: 'Gaborone',
        continent: 'AF',
        dial: '267',
        geoname_id: '933860',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    BVT: {
        official_name_en: 'Bouvet Island',
        iso3166alpha2: 'BV',
        iso3166alpha3: 'BVT',
        cldr_display_name: 'Bouvet Island',
        capital: '',
        continent: 'AN',
        dial: '47',
        geoname_id: '3371123',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Territory of NO'
    },
    BRA: {
        official_name_en: 'Brazil',
        iso3166alpha2: 'BR',
        iso3166alpha3: 'BRA',
        cldr_display_name: 'Brazil',
        capital: 'Brasilia',
        continent: 'SA',
        dial: '55',
        geoname_id: '3469034',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    IOT: {
        official_name_en: 'British Indian Ocean Territory',
        iso3166alpha2: 'IO',
        iso3166alpha3: 'IOT',
        cldr_display_name: 'British Indian Ocean Territory',
        capital: 'Diego Garcia',
        continent: 'AS',
        dial: '246',
        geoname_id: '1282588',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Territory of GB'
    },
    VGB: {
        official_name_en: 'British Virgin Islands',
        iso3166alpha2: 'VG',
        iso3166alpha3: 'VGB',
        cldr_display_name: 'British Virgin Islands',
        oldCountryName: 'Virgin Islands, British',
        capital: 'Road Town',
        continent: 'NA',
        dial: '1-284',
        geoname_id: '3577718',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Territory of GB'
    },
    BRN: {
        official_name_en: 'Brunei Darussalam',
        iso3166alpha2: 'BN',
        iso3166alpha3: 'BRN',
        cldr_display_name: 'Brunei',
        capital: 'Bandar Seri Begawan',
        continent: 'AS',
        dial: '673',
        geoname_id: '1820814',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '35',
        subregion_name: 'South-eastern Asia',
        is_independent: 'Yes'
    },
    BGR: {
        official_name_en: 'Bulgaria',
        iso3166alpha2: 'BG',
        iso3166alpha3: 'BGR',
        cldr_display_name: 'Bulgaria',
        capital: 'Sofia',
        continent: 'EU',
        dial: '359',
        geoname_id: '732800',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '151',
        subregion_name: 'Eastern Europe',
        is_independent: 'Yes'
    },
    BFA: {
        official_name_en: 'Burkina Faso',
        iso3166alpha2: 'BF',
        iso3166alpha3: 'BFA',
        cldr_display_name: 'Burkina Faso',
        capital: 'Ouagadougou',
        continent: 'AF',
        dial: '226',
        geoname_id: '2361809',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    BDI: {
        official_name_en: 'Burundi',
        iso3166alpha2: 'BI',
        iso3166alpha3: 'BDI',
        cldr_display_name: 'Burundi',
        capital: 'Bujumbura',
        continent: 'AF',
        dial: '257',
        geoname_id: '433561',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    CPV: {
        official_name_en: 'Cabo Verde',
        iso3166alpha2: 'CV',
        iso3166alpha3: 'CPV',
        cldr_display_name: 'Cape Verde',
        capital: 'Praia',
        continent: 'AF',
        dial: '238',
        geoname_id: '3374766',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    KHM: {
        official_name_en: 'Cambodia',
        iso3166alpha2: 'KH',
        iso3166alpha3: 'KHM',
        cldr_display_name: 'Cambodia',
        capital: 'Phnom Penh',
        continent: 'AS',
        dial: '855',
        geoname_id: '1831722',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '35',
        subregion_name: 'South-eastern Asia',
        is_independent: 'Yes'
    },
    CMR: {
        official_name_en: 'Cameroon',
        iso3166alpha2: 'CM',
        iso3166alpha3: 'CMR',
        cldr_display_name: 'Cameroon',
        capital: 'Yaounde',
        continent: 'AF',
        dial: '237',
        geoname_id: '2233387',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    CAN: {
        official_name_en: 'Canada',
        iso3166alpha2: 'CA',
        iso3166alpha3: 'CAN',
        cldr_display_name: 'Canada',
        capital: 'Ottawa',
        continent: 'NA',
        dial: '1',
        geoname_id: '6251999',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '21',
        subregion_name: 'Northern America',
        is_independent: 'Yes'
    },
    CYM: {
        official_name_en: 'Cayman Islands',
        iso3166alpha2: 'KY',
        iso3166alpha3: 'CYM',
        cldr_display_name: 'Cayman Islands',
        capital: 'George Town',
        continent: 'NA',
        dial: '1-345',
        geoname_id: '3580718',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Territory of GB'
    },
    CAF: {
        official_name_en: 'Central African Republic',
        iso3166alpha2: 'CF',
        iso3166alpha3: 'CAF',
        cldr_display_name: 'Central African Republic',
        capital: 'Bangui',
        continent: 'AF',
        dial: '236',
        geoname_id: '239880',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    TCD: {
        official_name_en: 'Chad',
        iso3166alpha2: 'TD',
        iso3166alpha3: 'TCD',
        cldr_display_name: 'Chad',
        capital: "N'Djamena",
        continent: 'AF',
        dial: '235',
        geoname_id: '2434508',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    CHL: {
        official_name_en: 'Chile',
        iso3166alpha2: 'CL',
        iso3166alpha3: 'CHL',
        cldr_display_name: 'Chile',
        capital: 'Santiago',
        continent: 'SA',
        dial: '56',
        geoname_id: '3895114',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    CHN: {
        official_name_en: 'China',
        iso3166alpha2: 'CN',
        iso3166alpha3: 'CHN',
        cldr_display_name: 'China',
        capital: 'Beijing',
        continent: 'AS',
        dial: '86',
        geoname_id: '1814991',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '30',
        subregion_name: 'Eastern Asia',
        is_independent: 'Yes'
    },
    HKG: {
        official_name_en: 'China, Hong Kong Special Administrative Region',
        iso3166alpha2: 'HK',
        iso3166alpha3: 'HKG',
        cldr_display_name: 'Hong Kong',
        capital: 'Hong Kong',
        continent: 'AS',
        dial: '852',
        geoname_id: '1819730',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '30',
        subregion_name: 'Eastern Asia',
        is_independent: 'Part of CN'
    },
    MAC: {
        official_name_en: 'China, Macao Special Administrative Region',
        iso3166alpha2: 'MO',
        iso3166alpha3: 'MAC',
        cldr_display_name: 'Macau',
        oldCountryName: 'Macao',
        capital: 'Macao',
        continent: 'AS',
        dial: '853',
        geoname_id: '1821275',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '30',
        subregion_name: 'Eastern Asia',
        is_independent: 'Part of CN'
    },
    CXR: {
        official_name_en: 'Christmas Island',
        iso3166alpha2: 'CX',
        iso3166alpha3: 'CXR',
        cldr_display_name: 'Christmas Island',
        capital: 'Flying Fish Cove',
        continent: 'AS',
        dial: '61',
        geoname_id: '2078138',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '53',
        subregion_name: 'Australia and New Zealand',
        is_independent: 'Territory of AU'
    },
    CCK: {
        official_name_en: 'Cocos (Keeling) Islands',
        iso3166alpha2: 'CC',
        iso3166alpha3: 'CCK',
        cldr_display_name: 'Cocos (Keeling) Islands',
        capital: 'West Island',
        continent: 'AS',
        dial: '61',
        geoname_id: '1547376',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '53',
        subregion_name: 'Australia and New Zealand',
        is_independent: 'Territory of AU'
    },
    COL: {
        official_name_en: 'Colombia',
        iso3166alpha2: 'CO',
        iso3166alpha3: 'COL',
        cldr_display_name: 'Colombia',
        capital: 'Bogota',
        continent: 'SA',
        dial: '57',
        geoname_id: '3686110',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    COM: {
        official_name_en: 'Comoros',
        iso3166alpha2: 'KM',
        iso3166alpha3: 'COM',
        cldr_display_name: 'Comoros',
        capital: 'Moroni',
        continent: 'AF',
        dial: '269',
        geoname_id: '921929',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    COG: {
        official_name_en: 'Congo',
        iso3166alpha2: 'CG',
        iso3166alpha3: 'COG',
        cldr_display_name: 'Congo - Brazzaville',
        oldCountryName: 'Congo, The Democratic Republic of the',
        capital: 'Brazzaville',
        continent: 'AF',
        dial: '242',
        geoname_id: '2260494',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    COK: {
        official_name_en: 'Cook Islands',
        iso3166alpha2: 'CK',
        iso3166alpha3: 'COK',
        cldr_display_name: 'Cook Islands',
        capital: 'Avarua',
        continent: 'OC',
        dial: '682',
        geoname_id: '1899402',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '61',
        subregion_name: 'Polynesia',
        is_independent: 'Associated with NZ'
    },
    CRI: {
        official_name_en: 'Costa Rica',
        iso3166alpha2: 'CR',
        iso3166alpha3: 'CRI',
        cldr_display_name: 'Costa Rica',
        capital: 'San Jose',
        continent: 'NA',
        dial: '506',
        geoname_id: '3624060',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    HRV: {
        official_name_en: 'Croatia',
        iso3166alpha2: 'HR',
        iso3166alpha3: 'HRV',
        cldr_display_name: 'Croatia',
        capital: 'Zagreb',
        continent: 'EU',
        dial: '385',
        geoname_id: '3202326',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '39',
        subregion_name: 'Southern Europe',
        is_independent: 'Yes'
    },
    CUB: {
        official_name_en: 'Cuba',
        iso3166alpha2: 'CU',
        iso3166alpha3: 'CUB',
        cldr_display_name: 'Cuba',
        capital: 'Havana',
        continent: 'NA',
        dial: '53',
        geoname_id: '3562981',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    CUW: {
        official_name_en: 'Curaçao',
        iso3166alpha2: 'CW',
        iso3166alpha3: 'CUW',
        cldr_display_name: 'Curaçao',
        capital: 'Willemstad',
        continent: 'NA',
        dial: '599',
        geoname_id: '7626836',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Part of NL'
    },
    CYP: {
        official_name_en: 'Cyprus',
        iso3166alpha2: 'CY',
        iso3166alpha3: 'CYP',
        cldr_display_name: 'Cyprus',
        capital: 'Nicosia',
        continent: 'EU',
        dial: '357',
        geoname_id: '146669',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '145',
        subregion_name: 'Western Asia',
        is_independent: 'Yes'
    },
    CZE: {
        official_name_en: 'Czechia',
        iso3166alpha2: 'CZ',
        iso3166alpha3: 'CZE',
        cldr_display_name: 'Czechia',
        oldCountryName: 'Czech Republic',
        capital: 'Prague',
        continent: 'EU',
        dial: '420',
        geoname_id: '3077311',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '151',
        subregion_name: 'Eastern Europe',
        is_independent: 'Yes'
    },
    CIV: {
        official_name_en: "Côte d'Ivoire",
        iso3166alpha2: 'CI',
        iso3166alpha3: 'CIV',
        cldr_display_name: "Côte d'Ivoire",
        oldCountryName: "Cote d'Ivoire",
        capital: 'Yamoussoukro',
        continent: 'AF',
        dial: '225',
        geoname_id: '2287781',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    PRK: {
        official_name_en: "Democratic People's Republic of Korea",
        iso3166alpha2: 'KP',
        iso3166alpha3: 'PRK',
        cldr_display_name: 'North Korea',
        capital: 'Pyongyang',
        continent: 'AS',
        dial: '850',
        geoname_id: '1873107',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '30',
        subregion_name: 'Eastern Asia',
        is_independent: 'Yes'
    },
    COD: {
        official_name_en: 'Democratic Republic of the Congo',
        iso3166alpha2: 'CD',
        iso3166alpha3: 'COD',
        cldr_display_name: 'Congo - Kinshasa',
        capital: 'Kinshasa',
        continent: 'AF',
        dial: '243',
        geoname_id: '203312',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    DNK: {
        official_name_en: 'Denmark',
        iso3166alpha2: 'DK',
        iso3166alpha3: 'DNK',
        cldr_display_name: 'Denmark',
        capital: 'Copenhagen',
        continent: 'EU',
        dial: '45',
        geoname_id: '2623032',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '154',
        subregion_name: 'Northern Europe',
        is_independent: 'Yes'
    },
    DJI: {
        official_name_en: 'Djibouti',
        iso3166alpha2: 'DJ',
        iso3166alpha3: 'DJI',
        cldr_display_name: 'Djibouti',
        capital: 'Djibouti',
        continent: 'AF',
        dial: '253',
        geoname_id: '223816',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    DMA: {
        official_name_en: 'Dominica',
        iso3166alpha2: 'DM',
        iso3166alpha3: 'DMA',
        cldr_display_name: 'Dominica',
        capital: 'Roseau',
        continent: 'NA',
        dial: '1-767',
        geoname_id: '3575830',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    DOM: {
        official_name_en: 'Dominican Republic',
        iso3166alpha2: 'DO',
        iso3166alpha3: 'DOM',
        cldr_display_name: 'Dominican Republic',
        capital: 'Santo Domingo',
        continent: 'NA',
        dial: '1-809,1-829,1-849',
        geoname_id: '3508796',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    ECU: {
        official_name_en: 'Ecuador',
        iso3166alpha2: 'EC',
        iso3166alpha3: 'ECU',
        cldr_display_name: 'Ecuador',
        capital: 'Quito',
        continent: 'SA',
        dial: '593',
        geoname_id: '3658394',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    EGY: {
        official_name_en: 'Egypt',
        iso3166alpha2: 'EG',
        iso3166alpha3: 'EGY',
        cldr_display_name: 'Egypt',
        capital: 'Cairo',
        continent: 'AF',
        dial: '20',
        geoname_id: '357994',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '15',
        subregion_name: 'Northern Africa',
        is_independent: 'Yes'
    },
    SLV: {
        official_name_en: 'El Salvador',
        iso3166alpha2: 'SV',
        iso3166alpha3: 'SLV',
        cldr_display_name: 'El Salvador',
        capital: 'San Salvador',
        continent: 'NA',
        dial: '503',
        geoname_id: '3585968',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    GNQ: {
        official_name_en: 'Equatorial Guinea',
        iso3166alpha2: 'GQ',
        iso3166alpha3: 'GNQ',
        cldr_display_name: 'Equatorial Guinea',
        capital: 'Malabo',
        continent: 'AF',
        dial: '240',
        geoname_id: '2309096',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    ERI: {
        official_name_en: 'Eritrea',
        iso3166alpha2: 'ER',
        iso3166alpha3: 'ERI',
        cldr_display_name: 'Eritrea',
        capital: 'Asmara',
        continent: 'AF',
        dial: '291',
        geoname_id: '338010',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    EST: {
        official_name_en: 'Estonia',
        iso3166alpha2: 'EE',
        iso3166alpha3: 'EST',
        cldr_display_name: 'Estonia',
        capital: 'Tallinn',
        continent: 'EU',
        dial: '372',
        geoname_id: '453733',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '154',
        subregion_name: 'Northern Europe',
        is_independent: 'Yes'
    },
    ETH: {
        official_name_en: 'Ethiopia',
        iso3166alpha2: 'ET',
        iso3166alpha3: 'ETH',
        cldr_display_name: 'Ethiopia',
        capital: 'Addis Ababa',
        continent: 'AF',
        dial: '251',
        geoname_id: '337996',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    FLK: {
        official_name_en: 'Falkland Islands (Malvinas)',
        iso3166alpha2: 'FK',
        iso3166alpha3: 'FLK',
        cldr_display_name: 'Falkland Islands',
        capital: 'Stanley',
        continent: 'SA',
        dial: '500',
        geoname_id: '3474414',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Territory of GB'
    },
    FRO: {
        official_name_en: 'Faroe Islands',
        iso3166alpha2: 'FO',
        iso3166alpha3: 'FRO',
        cldr_display_name: 'Faroe Islands',
        capital: 'Torshavn',
        continent: 'EU',
        dial: '298',
        geoname_id: '2622320',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '154',
        subregion_name: 'Northern Europe',
        is_independent: 'Part of DK'
    },
    FJI: {
        official_name_en: 'Fiji',
        iso3166alpha2: 'FJ',
        iso3166alpha3: 'FJI',
        cldr_display_name: 'Fiji',
        oldCountryName: 'Fiji Islands',
        capital: 'Suva',
        continent: 'OC',
        dial: '679',
        geoname_id: '2205218',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '54',
        subregion_name: 'Melanesia',
        is_independent: 'Yes'
    },
    FIN: {
        official_name_en: 'Finland',
        iso3166alpha2: 'FI',
        iso3166alpha3: 'FIN',
        cldr_display_name: 'Finland',
        capital: 'Helsinki',
        continent: 'EU',
        dial: '358',
        geoname_id: '660013',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '154',
        subregion_name: 'Northern Europe',
        is_independent: 'Yes'
    },
    FRA: {
        official_name_en: 'France',
        iso3166alpha2: 'FR',
        iso3166alpha3: 'FRA',
        cldr_display_name: 'France',
        capital: 'Paris',
        continent: 'EU',
        dial: '33',
        geoname_id: '3017382',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '155',
        subregion_name: 'Western Europe',
        is_independent: 'Yes'
    },
    GUF: {
        official_name_en: 'French Guiana',
        iso3166alpha2: 'GF',
        iso3166alpha3: 'GUF',
        cldr_display_name: 'French Guiana',
        capital: 'Cayenne',
        continent: 'SA',
        dial: '594',
        geoname_id: '3381670',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Part of FR'
    },
    PYF: {
        official_name_en: 'French Polynesia',
        iso3166alpha2: 'PF',
        iso3166alpha3: 'PYF',
        cldr_display_name: 'French Polynesia',
        capital: 'Papeete',
        continent: 'OC',
        dial: '689',
        geoname_id: '4030656',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '61',
        subregion_name: 'Polynesia',
        is_independent: 'Territory of FR'
    },
    ATF: {
        official_name_en: 'French Southern Territories',
        iso3166alpha2: 'TF',
        iso3166alpha3: 'ATF',
        cldr_display_name: 'French Southern Territories',
        capital: 'Port-aux-Francais',
        continent: 'AN',
        dial: '262',
        geoname_id: '1546748',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Territory of FR'
    },
    GAB: {
        official_name_en: 'Gabon',
        iso3166alpha2: 'GA',
        iso3166alpha3: 'GAB',
        cldr_display_name: 'Gabon',
        capital: 'Libreville',
        continent: 'AF',
        dial: '241',
        geoname_id: '2400553',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    GMB: {
        official_name_en: 'Gambia',
        iso3166alpha2: 'GM',
        iso3166alpha3: 'GMB',
        cldr_display_name: 'Gambia',
        capital: 'Banjul',
        continent: 'AF',
        dial: '220',
        geoname_id: '2413451',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    GEO: {
        official_name_en: 'Georgia',
        iso3166alpha2: 'GE',
        iso3166alpha3: 'GEO',
        cldr_display_name: 'Georgia',
        capital: 'Tbilisi',
        continent: 'AS',
        dial: '995',
        geoname_id: '614540',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '145',
        subregion_name: 'Western Asia',
        is_independent: 'Yes'
    },
    DEU: {
        official_name_en: 'Germany',
        iso3166alpha2: 'DE',
        iso3166alpha3: 'DEU',
        cldr_display_name: 'Germany',
        capital: 'Berlin',
        continent: 'EU',
        dial: '49',
        geoname_id: '2921044',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '155',
        subregion_name: 'Western Europe',
        is_independent: 'Yes'
    },
    GHA: {
        official_name_en: 'Ghana',
        iso3166alpha2: 'GH',
        iso3166alpha3: 'GHA',
        cldr_display_name: 'Ghana',
        capital: 'Accra',
        continent: 'AF',
        dial: '233',
        geoname_id: '2300660',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    GIB: {
        official_name_en: 'Gibraltar',
        iso3166alpha2: 'GI',
        iso3166alpha3: 'GIB',
        cldr_display_name: 'Gibraltar',
        capital: 'Gibraltar',
        continent: 'EU',
        dial: '350',
        geoname_id: '2411586',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '39',
        subregion_name: 'Southern Europe',
        is_independent: 'Territory of GB'
    },
    GRC: {
        official_name_en: 'Greece',
        iso3166alpha2: 'GR',
        iso3166alpha3: 'GRC',
        cldr_display_name: 'Greece',
        capital: 'Athens',
        continent: 'EU',
        dial: '30',
        geoname_id: '390903',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '39',
        subregion_name: 'Southern Europe',
        is_independent: 'Yes'
    },
    GRL: {
        official_name_en: 'Greenland',
        iso3166alpha2: 'GL',
        iso3166alpha3: 'GRL',
        cldr_display_name: 'Greenland',
        capital: 'Nuuk',
        continent: 'NA',
        dial: '299',
        geoname_id: '3425505',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '21',
        subregion_name: 'Northern America',
        is_independent: 'Part of DK'
    },
    GRD: {
        official_name_en: 'Grenada',
        iso3166alpha2: 'GD',
        iso3166alpha3: 'GRD',
        cldr_display_name: 'Grenada',
        capital: "St. George's",
        continent: 'NA',
        dial: '1-473',
        geoname_id: '3580239',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    GLP: {
        official_name_en: 'Guadeloupe',
        iso3166alpha2: 'GP',
        iso3166alpha3: 'GLP',
        cldr_display_name: 'Guadeloupe',
        capital: 'Basse-Terre',
        continent: 'NA',
        dial: '590',
        geoname_id: '3579143',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Part of FR'
    },
    GUM: {
        official_name_en: 'Guam',
        iso3166alpha2: 'GU',
        iso3166alpha3: 'GUM',
        cldr_display_name: 'Guam',
        capital: 'Hagatna',
        continent: 'OC',
        dial: '1-671',
        geoname_id: '4043988',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '57',
        subregion_name: 'Micronesia',
        is_independent: 'Territory of US'
    },
    GTM: {
        official_name_en: 'Guatemala',
        iso3166alpha2: 'GT',
        iso3166alpha3: 'GTM',
        cldr_display_name: 'Guatemala',
        capital: 'Guatemala City',
        continent: 'NA',
        dial: '502',
        geoname_id: '3595528',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    GGY: {
        official_name_en: 'Guernsey',
        iso3166alpha2: 'GG',
        iso3166alpha3: 'GGY',
        cldr_display_name: 'Guernsey',
        capital: 'St Peter Port',
        continent: 'EU',
        dial: '44',
        geoname_id: '3042362',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '154',
        subregion_name: 'Northern Europe',
        is_independent: 'Crown dependency of GB'
    },
    GIN: {
        official_name_en: 'Guinea',
        iso3166alpha2: 'GN',
        iso3166alpha3: 'GIN',
        cldr_display_name: 'Guinea',
        capital: 'Conakry',
        continent: 'AF',
        dial: '224',
        geoname_id: '2420477',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    GNB: {
        official_name_en: 'Guinea-Bissau',
        iso3166alpha2: 'GW',
        iso3166alpha3: 'GNB',
        cldr_display_name: 'Guinea-Bissau',
        capital: 'Bissau',
        continent: 'AF',
        dial: '245',
        geoname_id: '2372248',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    GUY: {
        official_name_en: 'Guyana',
        iso3166alpha2: 'GY',
        iso3166alpha3: 'GUY',
        cldr_display_name: 'Guyana',
        capital: 'Georgetown',
        continent: 'SA',
        dial: '592',
        geoname_id: '3378535',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    HTI: {
        official_name_en: 'Haiti',
        iso3166alpha2: 'HT',
        iso3166alpha3: 'HTI',
        cldr_display_name: 'Haiti',
        capital: 'Port-au-Prince',
        continent: 'NA',
        dial: '509',
        geoname_id: '3723988',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    HMD: {
        official_name_en: 'Heard Island and McDonald Islands',
        iso3166alpha2: 'HM',
        iso3166alpha3: 'HMD',
        cldr_display_name: 'Heard & McDonald Islands',
        capital: '',
        continent: 'AN',
        dial: '672',
        geoname_id: '1547314',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '53',
        subregion_name: 'Australia and New Zealand',
        is_independent: 'Territory of AU'
    },
    VAT: {
        official_name_en: 'Holy See',
        iso3166alpha2: 'VA',
        iso3166alpha3: 'VAT',
        cldr_display_name: 'Vatican City',
        oldCountryName: 'Holy See (Vatican City State)',
        capital: 'Vatican City',
        continent: 'EU',
        dial: '39-06',
        geoname_id: '3164670',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '39',
        subregion_name: 'Southern Europe',
        is_independent: 'Yes'
    },
    HND: {
        official_name_en: 'Honduras',
        iso3166alpha2: 'HN',
        iso3166alpha3: 'HND',
        cldr_display_name: 'Honduras',
        capital: 'Tegucigalpa',
        continent: 'NA',
        dial: '504',
        geoname_id: '3608932',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    HUN: {
        official_name_en: 'Hungary',
        iso3166alpha2: 'HU',
        iso3166alpha3: 'HUN',
        cldr_display_name: 'Hungary',
        capital: 'Budapest',
        continent: 'EU',
        dial: '36',
        geoname_id: '719819',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '151',
        subregion_name: 'Eastern Europe',
        is_independent: 'Yes'
    },
    ISL: {
        official_name_en: 'Iceland',
        iso3166alpha2: 'IS',
        iso3166alpha3: 'ISL',
        cldr_display_name: 'Iceland',
        capital: 'Reykjavik',
        continent: 'EU',
        dial: '354',
        geoname_id: '2629691',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '154',
        subregion_name: 'Northern Europe',
        is_independent: 'Yes'
    },
    IND: {
        official_name_en: 'India',
        iso3166alpha2: 'IN',
        iso3166alpha3: 'IND',
        cldr_display_name: 'India',
        capital: 'New Delhi',
        continent: 'AS',
        dial: '91',
        geoname_id: '1269750',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '34',
        subregion_name: 'Southern Asia',
        is_independent: 'Yes'
    },
    IDN: {
        official_name_en: 'Indonesia',
        iso3166alpha2: 'ID',
        iso3166alpha3: 'IDN',
        cldr_display_name: 'Indonesia',
        capital: 'Jakarta',
        continent: 'AS',
        dial: '62',
        geoname_id: '1643084',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '35',
        subregion_name: 'South-eastern Asia',
        is_independent: 'Yes'
    },
    IRN: {
        official_name_en: 'Iran (Islamic Republic of)',
        iso3166alpha2: 'IR',
        iso3166alpha3: 'IRN',
        cldr_display_name: 'Iran',
        capital: 'Tehran',
        continent: 'AS',
        dial: '98',
        geoname_id: '130758',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '34',
        subregion_name: 'Southern Asia',
        is_independent: 'Yes'
    },
    IRQ: {
        official_name_en: 'Iraq',
        iso3166alpha2: 'IQ',
        iso3166alpha3: 'IRQ',
        cldr_display_name: 'Iraq',
        capital: 'Baghdad',
        continent: 'AS',
        dial: '964',
        geoname_id: '99237',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '145',
        subregion_name: 'Western Asia',
        is_independent: 'Yes'
    },
    IRL: {
        official_name_en: 'Ireland',
        iso3166alpha2: 'IE',
        iso3166alpha3: 'IRL',
        cldr_display_name: 'Ireland',
        capital: 'Dublin',
        continent: 'EU',
        dial: '353',
        geoname_id: '2963597',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '154',
        subregion_name: 'Northern Europe',
        is_independent: 'Yes'
    },
    IMN: {
        official_name_en: 'Isle of Man',
        iso3166alpha2: 'IM',
        iso3166alpha3: 'IMN',
        cldr_display_name: 'Isle of Man',
        capital: 'Douglas',
        continent: 'EU',
        dial: '44',
        geoname_id: '3042225',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '154',
        subregion_name: 'Northern Europe',
        is_independent: 'Crown dependency of GB'
    },
    ISR: {
        official_name_en: 'Israel',
        iso3166alpha2: 'IL',
        iso3166alpha3: 'ISR',
        cldr_display_name: 'Israel',
        capital: 'Jerusalem',
        continent: 'AS',
        dial: '972',
        geoname_id: '294640',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '145',
        subregion_name: 'Western Asia',
        is_independent: 'Yes'
    },
    ITA: {
        official_name_en: 'Italy',
        iso3166alpha2: 'IT',
        iso3166alpha3: 'ITA',
        cldr_display_name: 'Italy',
        capital: 'Rome',
        continent: 'EU',
        dial: '39',
        geoname_id: '3175395',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '39',
        subregion_name: 'Southern Europe',
        is_independent: 'Yes'
    },
    JAM: {
        official_name_en: 'Jamaica',
        iso3166alpha2: 'JM',
        iso3166alpha3: 'JAM',
        cldr_display_name: 'Jamaica',
        capital: 'Kingston',
        continent: 'NA',
        dial: '1-876',
        geoname_id: '3489940',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    JPN: {
        official_name_en: 'Japan',
        iso3166alpha2: 'JP',
        iso3166alpha3: 'JPN',
        cldr_display_name: 'Japan',
        capital: 'Tokyo',
        continent: 'AS',
        dial: '81',
        geoname_id: '1861060',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '30',
        subregion_name: 'Eastern Asia',
        is_independent: 'Yes'
    },
    JEY: {
        official_name_en: 'Jersey',
        iso3166alpha2: 'JE',
        iso3166alpha3: 'JEY',
        cldr_display_name: 'Jersey',
        capital: 'Saint Helier',
        continent: 'EU',
        dial: '44',
        geoname_id: '3042142',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '154',
        subregion_name: 'Northern Europe',
        is_independent: 'Crown dependency of GB'
    },
    JOR: {
        official_name_en: 'Jordan',
        iso3166alpha2: 'JO',
        iso3166alpha3: 'JOR',
        cldr_display_name: 'Jordan',
        capital: 'Amman',
        continent: 'AS',
        dial: '962',
        geoname_id: '248816',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '145',
        subregion_name: 'Western Asia',
        is_independent: 'Yes'
    },
    KAZ: {
        official_name_en: 'Kazakhstan',
        iso3166alpha2: 'KZ',
        iso3166alpha3: 'KAZ',
        cldr_display_name: 'Kazakhstan',
        oldCountryName: 'Kazakstan',
        capital: 'Astana',
        continent: 'AS',
        dial: '7',
        geoname_id: '1522867',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '143',
        subregion_name: 'Central Asia',
        is_independent: 'Yes'
    },
    KEN: {
        official_name_en: 'Kenya',
        iso3166alpha2: 'KE',
        iso3166alpha3: 'KEN',
        cldr_display_name: 'Kenya',
        capital: 'Nairobi',
        continent: 'AF',
        dial: '254',
        geoname_id: '192950',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    KIR: {
        official_name_en: 'Kiribati',
        iso3166alpha2: 'KI',
        iso3166alpha3: 'KIR',
        cldr_display_name: 'Kiribati',
        capital: 'Tarawa',
        continent: 'OC',
        dial: '686',
        geoname_id: '4030945',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '57',
        subregion_name: 'Micronesia',
        is_independent: 'Yes'
    },
    KWT: {
        official_name_en: 'Kuwait',
        iso3166alpha2: 'KW',
        iso3166alpha3: 'KWT',
        cldr_display_name: 'Kuwait',
        capital: 'Kuwait City',
        continent: 'AS',
        dial: '965',
        geoname_id: '285570',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '145',
        subregion_name: 'Western Asia',
        is_independent: 'Yes'
    },
    KGZ: {
        official_name_en: 'Kyrgyzstan',
        iso3166alpha2: 'KG',
        iso3166alpha3: 'KGZ',
        cldr_display_name: 'Kyrgyzstan',
        capital: 'Bishkek',
        continent: 'AS',
        dial: '996',
        geoname_id: '1527747',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '143',
        subregion_name: 'Central Asia',
        is_independent: 'Yes'
    },
    LAO: {
        official_name_en: "Lao People's Democratic Republic",
        iso3166alpha2: 'LA',
        iso3166alpha3: 'LAO',
        cldr_display_name: 'Laos',
        capital: 'Vientiane',
        continent: 'AS',
        dial: '856',
        geoname_id: '1655842',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '35',
        subregion_name: 'South-eastern Asia',
        is_independent: 'Yes'
    },
    LVA: {
        official_name_en: 'Latvia',
        iso3166alpha2: 'LV',
        iso3166alpha3: 'LVA',
        cldr_display_name: 'Latvia',
        capital: 'Riga',
        continent: 'EU',
        dial: '371',
        geoname_id: '458258',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '154',
        subregion_name: 'Northern Europe',
        is_independent: 'Yes'
    },
    LBN: {
        official_name_en: 'Lebanon',
        iso3166alpha2: 'LB',
        iso3166alpha3: 'LBN',
        cldr_display_name: 'Lebanon',
        capital: 'Beirut',
        continent: 'AS',
        dial: '961',
        geoname_id: '272103',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '145',
        subregion_name: 'Western Asia',
        is_independent: 'Yes'
    },
    LSO: {
        official_name_en: 'Lesotho',
        iso3166alpha2: 'LS',
        iso3166alpha3: 'LSO',
        cldr_display_name: 'Lesotho',
        capital: 'Maseru',
        continent: 'AF',
        dial: '266',
        geoname_id: '932692',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    LBR: {
        official_name_en: 'Liberia',
        iso3166alpha2: 'LR',
        iso3166alpha3: 'LBR',
        cldr_display_name: 'Liberia',
        capital: 'Monrovia',
        continent: 'AF',
        dial: '231',
        geoname_id: '2275384',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    LBY: {
        official_name_en: 'Libya',
        iso3166alpha2: 'LY',
        iso3166alpha3: 'LBY',
        cldr_display_name: 'Libya',
        capital: 'Tripoli',
        continent: 'AF',
        dial: '218',
        geoname_id: '2215636',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '15',
        subregion_name: 'Northern Africa',
        is_independent: 'Yes'
    },
    LIE: {
        official_name_en: 'Liechtenstein',
        iso3166alpha2: 'LI',
        iso3166alpha3: 'LIE',
        cldr_display_name: 'Liechtenstein',
        capital: 'Vaduz',
        continent: 'EU',
        dial: '423',
        geoname_id: '3042058',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '155',
        subregion_name: 'Western Europe',
        is_independent: 'Yes'
    },
    LTU: {
        official_name_en: 'Lithuania',
        iso3166alpha2: 'LT',
        iso3166alpha3: 'LTU',
        cldr_display_name: 'Lithuania',
        capital: 'Vilnius',
        continent: 'EU',
        dial: '370',
        geoname_id: '597427',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '154',
        subregion_name: 'Northern Europe',
        is_independent: 'Yes'
    },
    LUX: {
        official_name_en: 'Luxembourg',
        iso3166alpha2: 'LU',
        iso3166alpha3: 'LUX',
        cldr_display_name: 'Luxembourg',
        capital: 'Luxembourg',
        continent: 'EU',
        dial: '352',
        geoname_id: '2960313',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '155',
        subregion_name: 'Western Europe',
        is_independent: 'Yes'
    },
    MDG: {
        official_name_en: 'Madagascar',
        iso3166alpha2: 'MG',
        iso3166alpha3: 'MDG',
        cldr_display_name: 'Madagascar',
        capital: 'Antananarivo',
        continent: 'AF',
        dial: '261',
        geoname_id: '1062947',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    MWI: {
        official_name_en: 'Malawi',
        iso3166alpha2: 'MW',
        iso3166alpha3: 'MWI',
        cldr_display_name: 'Malawi',
        capital: 'Lilongwe',
        continent: 'AF',
        dial: '265',
        geoname_id: '927384',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    MYS: {
        official_name_en: 'Malaysia',
        iso3166alpha2: 'MY',
        iso3166alpha3: 'MYS',
        cldr_display_name: 'Malaysia',
        capital: 'Kuala Lumpur',
        continent: 'AS',
        dial: '60',
        geoname_id: '1733045',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '35',
        subregion_name: 'South-eastern Asia',
        is_independent: 'Yes'
    },
    MDV: {
        official_name_en: 'Maldives',
        iso3166alpha2: 'MV',
        iso3166alpha3: 'MDV',
        cldr_display_name: 'Maldives',
        capital: 'Male',
        continent: 'AS',
        dial: '960',
        geoname_id: '1282028',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '34',
        subregion_name: 'Southern Asia',
        is_independent: 'Yes'
    },
    MLI: {
        official_name_en: 'Mali',
        iso3166alpha2: 'ML',
        iso3166alpha3: 'MLI',
        cldr_display_name: 'Mali',
        capital: 'Bamako',
        continent: 'AF',
        dial: '223',
        geoname_id: '2453866',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    MLT: {
        official_name_en: 'Malta',
        iso3166alpha2: 'MT',
        iso3166alpha3: 'MLT',
        cldr_display_name: 'Malta',
        capital: 'Valletta',
        continent: 'EU',
        dial: '356',
        geoname_id: '2562770',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '39',
        subregion_name: 'Southern Europe',
        is_independent: 'Yes'
    },
    MHL: {
        official_name_en: 'Marshall Islands',
        iso3166alpha2: 'MH',
        iso3166alpha3: 'MHL',
        cldr_display_name: 'Marshall Islands',
        capital: 'Majuro',
        continent: 'OC',
        dial: '692',
        geoname_id: '2080185',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '57',
        subregion_name: 'Micronesia',
        is_independent: 'Yes'
    },
    MTQ: {
        official_name_en: 'Martinique',
        iso3166alpha2: 'MQ',
        iso3166alpha3: 'MTQ',
        cldr_display_name: 'Martinique',
        capital: 'Fort-de-France',
        continent: 'NA',
        dial: '596',
        geoname_id: '3570311',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Part of FR'
    },
    MRT: {
        official_name_en: 'Mauritania',
        iso3166alpha2: 'MR',
        iso3166alpha3: 'MRT',
        cldr_display_name: 'Mauritania',
        capital: 'Nouakchott',
        continent: 'AF',
        dial: '222',
        geoname_id: '2378080',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    MUS: {
        official_name_en: 'Mauritius',
        iso3166alpha2: 'MU',
        iso3166alpha3: 'MUS',
        cldr_display_name: 'Mauritius',
        capital: 'Port Louis',
        continent: 'AF',
        dial: '230',
        geoname_id: '934292',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    MYT: {
        official_name_en: 'Mayotte',
        iso3166alpha2: 'YT',
        iso3166alpha3: 'MYT',
        cldr_display_name: 'Mayotte',
        capital: 'Mamoudzou',
        continent: 'AF',
        dial: '262',
        geoname_id: '1024031',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Part of FR'
    },
    MEX: {
        official_name_en: 'Mexico',
        iso3166alpha2: 'MX',
        iso3166alpha3: 'MEX',
        cldr_display_name: 'Mexico',
        capital: 'Mexico City',
        continent: 'NA',
        dial: '52',
        geoname_id: '3996063',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    FSM: {
        official_name_en: 'Micronesia (Federated States of)',
        iso3166alpha2: 'FM',
        iso3166alpha3: 'FSM',
        cldr_display_name: 'Micronesia',
        oldCountryName: 'Micronesia, Federated States of',
        capital: 'Palikir',
        continent: 'OC',
        dial: '691',
        geoname_id: '2081918',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '57',
        subregion_name: 'Micronesia',
        is_independent: 'Yes'
    },
    MCO: {
        official_name_en: 'Monaco',
        iso3166alpha2: 'MC',
        iso3166alpha3: 'MCO',
        cldr_display_name: 'Monaco',
        capital: 'Monaco',
        continent: 'EU',
        dial: '377',
        geoname_id: '2993457',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '155',
        subregion_name: 'Western Europe',
        is_independent: 'Yes'
    },
    MNG: {
        official_name_en: 'Mongolia',
        iso3166alpha2: 'MN',
        iso3166alpha3: 'MNG',
        cldr_display_name: 'Mongolia',
        capital: 'Ulan Bator',
        continent: 'AS',
        dial: '976',
        geoname_id: '2029969',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '30',
        subregion_name: 'Eastern Asia',
        is_independent: 'Yes'
    },
    MNE: {
        official_name_en: 'Montenegro',
        iso3166alpha2: 'ME',
        iso3166alpha3: 'MNE',
        cldr_display_name: 'Montenegro',
        capital: 'Podgorica',
        continent: 'EU',
        dial: '382',
        geoname_id: '3194884',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '39',
        subregion_name: 'Southern Europe',
        is_independent: 'Yes'
    },
    MSR: {
        official_name_en: 'Montserrat',
        iso3166alpha2: 'MS',
        iso3166alpha3: 'MSR',
        cldr_display_name: 'Montserrat',
        capital: 'Plymouth',
        continent: 'NA',
        dial: '1-664',
        geoname_id: '3578097',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Territory of GB'
    },
    MAR: {
        official_name_en: 'Morocco',
        iso3166alpha2: 'MA',
        iso3166alpha3: 'MAR',
        cldr_display_name: 'Morocco',
        capital: 'Rabat',
        continent: 'AF',
        dial: '212',
        geoname_id: '2542007',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '15',
        subregion_name: 'Northern Africa',
        is_independent: 'Yes'
    },
    MOZ: {
        official_name_en: 'Mozambique',
        iso3166alpha2: 'MZ',
        iso3166alpha3: 'MOZ',
        cldr_display_name: 'Mozambique',
        capital: 'Maputo',
        continent: 'AF',
        dial: '258',
        geoname_id: '1036973',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    MMR: {
        official_name_en: 'Myanmar',
        iso3166alpha2: 'MM',
        iso3166alpha3: 'MMR',
        cldr_display_name: 'Myanmar',
        capital: 'Nay Pyi Taw',
        continent: 'AS',
        dial: '95',
        geoname_id: '1327865',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '35',
        subregion_name: 'South-eastern Asia',
        is_independent: 'Yes'
    },
    NAM: {
        official_name_en: 'Namibia',
        iso3166alpha2: 'NA',
        iso3166alpha3: 'NAM',
        cldr_display_name: 'Namibia',
        capital: 'Windhoek',
        continent: 'AF',
        dial: '264',
        geoname_id: '3355338',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    NRU: {
        official_name_en: 'Nauru',
        iso3166alpha2: 'NR',
        iso3166alpha3: 'NRU',
        cldr_display_name: 'Nauru',
        capital: 'Yaren',
        continent: 'OC',
        dial: '674',
        geoname_id: '2110425',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '57',
        subregion_name: 'Micronesia',
        is_independent: 'Yes'
    },
    NPL: {
        official_name_en: 'Nepal',
        iso3166alpha2: 'NP',
        iso3166alpha3: 'NPL',
        cldr_display_name: 'Nepal',
        capital: 'Kathmandu',
        continent: 'AS',
        dial: '977',
        geoname_id: '1282988',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '34',
        subregion_name: 'Southern Asia',
        is_independent: 'Yes'
    },
    NLD: {
        official_name_en: 'Netherlands',
        iso3166alpha2: 'NL',
        iso3166alpha3: 'NLD',
        cldr_display_name: 'Netherlands',
        capital: 'Amsterdam',
        continent: 'EU',
        dial: '31',
        geoname_id: '2750405',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '155',
        subregion_name: 'Western Europe',
        is_independent: 'Yes'
    },
    NCL: {
        official_name_en: 'New Caledonia',
        iso3166alpha2: 'NC',
        iso3166alpha3: 'NCL',
        cldr_display_name: 'New Caledonia',
        capital: 'Noumea',
        continent: 'OC',
        dial: '687',
        geoname_id: '2139685',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '54',
        subregion_name: 'Melanesia',
        is_independent: 'Territory of FR'
    },
    NZL: {
        official_name_en: 'New Zealand',
        iso3166alpha2: 'NZ',
        iso3166alpha3: 'NZL',
        cldr_display_name: 'New Zealand',
        capital: 'Wellington',
        continent: 'OC',
        dial: '64',
        geoname_id: '2186224',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '53',
        subregion_name: 'Australia and New Zealand',
        is_independent: 'Yes'
    },
    NIC: {
        official_name_en: 'Nicaragua',
        iso3166alpha2: 'NI',
        iso3166alpha3: 'NIC',
        cldr_display_name: 'Nicaragua',
        capital: 'Managua',
        continent: 'NA',
        dial: '505',
        geoname_id: '3617476',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    NER: {
        official_name_en: 'Niger',
        iso3166alpha2: 'NE',
        iso3166alpha3: 'NER',
        cldr_display_name: 'Niger',
        capital: 'Niamey',
        continent: 'AF',
        dial: '227',
        geoname_id: '2440476',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    NGA: {
        official_name_en: 'Nigeria',
        iso3166alpha2: 'NG',
        iso3166alpha3: 'NGA',
        cldr_display_name: 'Nigeria',
        capital: 'Abuja',
        continent: 'AF',
        dial: '234',
        geoname_id: '2328926',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    NIU: {
        official_name_en: 'Niue',
        iso3166alpha2: 'NU',
        iso3166alpha3: 'NIU',
        cldr_display_name: 'Niue',
        capital: 'Alofi',
        continent: 'OC',
        dial: '683',
        geoname_id: '4036232',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '61',
        subregion_name: 'Polynesia',
        is_independent: 'Associated with NZ'
    },
    NFK: {
        official_name_en: 'Norfolk Island',
        iso3166alpha2: 'NF',
        iso3166alpha3: 'NFK',
        cldr_display_name: 'Norfolk Island',
        capital: 'Kingston',
        continent: 'OC',
        dial: '672',
        geoname_id: '2155115',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '53',
        subregion_name: 'Australia and New Zealand',
        is_independent: 'Territory of AU'
    },
    MNP: {
        official_name_en: 'Northern Mariana Islands',
        iso3166alpha2: 'MP',
        iso3166alpha3: 'MNP',
        cldr_display_name: 'Northern Mariana Islands',
        capital: 'Saipan',
        continent: 'OC',
        dial: '1-670',
        geoname_id: '4041468',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '57',
        subregion_name: 'Micronesia',
        is_independent: 'Commonwealth of US'
    },
    NOR: {
        official_name_en: 'Norway',
        iso3166alpha2: 'NO',
        iso3166alpha3: 'NOR',
        cldr_display_name: 'Norway',
        capital: 'Oslo',
        continent: 'EU',
        dial: '47',
        geoname_id: '3144096',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '154',
        subregion_name: 'Northern Europe',
        is_independent: 'Yes'
    },
    OMN: {
        official_name_en: 'Oman',
        iso3166alpha2: 'OM',
        iso3166alpha3: 'OMN',
        cldr_display_name: 'Oman',
        capital: 'Muscat',
        continent: 'AS',
        dial: '968',
        geoname_id: '286963',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '145',
        subregion_name: 'Western Asia',
        is_independent: 'Yes'
    },
    PAK: {
        official_name_en: 'Pakistan',
        iso3166alpha2: 'PK',
        iso3166alpha3: 'PAK',
        cldr_display_name: 'Pakistan',
        capital: 'Islamabad',
        continent: 'AS',
        dial: '92',
        geoname_id: '1168579',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '34',
        subregion_name: 'Southern Asia',
        is_independent: 'Yes'
    },
    PLW: {
        official_name_en: 'Palau',
        iso3166alpha2: 'PW',
        iso3166alpha3: 'PLW',
        cldr_display_name: 'Palau',
        capital: 'Melekeok',
        continent: 'OC',
        dial: '680',
        geoname_id: '1559582',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '57',
        subregion_name: 'Micronesia',
        is_independent: 'Yes'
    },
    PAN: {
        official_name_en: 'Panama',
        iso3166alpha2: 'PA',
        iso3166alpha3: 'PAN',
        cldr_display_name: 'Panama',
        capital: 'Panama City',
        continent: 'NA',
        dial: '507',
        geoname_id: '3703430',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    PNG: {
        official_name_en: 'Papua New Guinea',
        iso3166alpha2: 'PG',
        iso3166alpha3: 'PNG',
        cldr_display_name: 'Papua New Guinea',
        capital: 'Port Moresby',
        continent: 'OC',
        dial: '675',
        geoname_id: '2088628',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '54',
        subregion_name: 'Melanesia',
        is_independent: 'Yes'
    },
    PRY: {
        official_name_en: 'Paraguay',
        iso3166alpha2: 'PY',
        iso3166alpha3: 'PRY',
        cldr_display_name: 'Paraguay',
        capital: 'Asuncion',
        continent: 'SA',
        dial: '595',
        geoname_id: '3437598',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    PER: {
        official_name_en: 'Peru',
        iso3166alpha2: 'PE',
        iso3166alpha3: 'PER',
        cldr_display_name: 'Peru',
        capital: 'Lima',
        continent: 'SA',
        dial: '51',
        geoname_id: '3932488',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    PHL: {
        official_name_en: 'Philippines',
        iso3166alpha2: 'PH',
        iso3166alpha3: 'PHL',
        cldr_display_name: 'Philippines',
        capital: 'Manila',
        continent: 'AS',
        dial: '63',
        geoname_id: '1694008',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '35',
        subregion_name: 'South-eastern Asia',
        is_independent: 'Yes'
    },
    PCN: {
        official_name_en: 'Pitcairn',
        iso3166alpha2: 'PN',
        iso3166alpha3: 'PCN',
        cldr_display_name: 'Pitcairn Islands',
        capital: 'Adamstown',
        continent: 'OC',
        dial: '870',
        geoname_id: '4030699',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '61',
        subregion_name: 'Polynesia',
        is_independent: 'Territory of GB'
    },
    POL: {
        official_name_en: 'Poland',
        iso3166alpha2: 'PL',
        iso3166alpha3: 'POL',
        cldr_display_name: 'Poland',
        capital: 'Warsaw',
        continent: 'EU',
        dial: '48',
        geoname_id: '798544',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '151',
        subregion_name: 'Eastern Europe',
        is_independent: 'Yes'
    },
    PRT: {
        official_name_en: 'Portugal',
        iso3166alpha2: 'PT',
        iso3166alpha3: 'PRT',
        cldr_display_name: 'Portugal',
        capital: 'Lisbon',
        continent: 'EU',
        dial: '351',
        geoname_id: '2264397',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '39',
        subregion_name: 'Southern Europe',
        is_independent: 'Yes'
    },
    PRI: {
        official_name_en: 'Puerto Rico',
        iso3166alpha2: 'PR',
        iso3166alpha3: 'PRI',
        cldr_display_name: 'Puerto Rico',
        capital: 'San Juan',
        continent: 'NA',
        dial: '1',
        geoname_id: '4566966',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Commonwealth of US'
    },
    QAT: {
        official_name_en: 'Qatar',
        iso3166alpha2: 'QA',
        iso3166alpha3: 'QAT',
        cldr_display_name: 'Qatar',
        capital: 'Doha',
        continent: 'AS',
        dial: '974',
        geoname_id: '289688',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '145',
        subregion_name: 'Western Asia',
        is_independent: 'Yes'
    },
    KOR: {
        official_name_en: 'Republic of Korea',
        iso3166alpha2: 'KR',
        iso3166alpha3: 'KOR',
        cldr_display_name: 'South Korea',
        capital: 'Seoul',
        continent: 'AS',
        dial: '82',
        geoname_id: '1835841',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '30',
        subregion_name: 'Eastern Asia',
        is_independent: 'Yes'
    },
    MDA: {
        official_name_en: 'Republic of Moldova',
        iso3166alpha2: 'MD',
        iso3166alpha3: 'MDA',
        cldr_display_name: 'Moldova',
        capital: 'Chisinau',
        continent: 'EU',
        dial: '373',
        geoname_id: '617790',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '151',
        subregion_name: 'Eastern Europe',
        is_independent: 'Yes'
    },
    ROU: {
        official_name_en: 'Romania',
        iso3166alpha2: 'RO',
        iso3166alpha3: 'ROU',
        cldr_display_name: 'Romania',
        capital: 'Bucharest',
        continent: 'EU',
        dial: '40',
        geoname_id: '798549',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '151',
        subregion_name: 'Eastern Europe',
        is_independent: 'Yes'
    },
    RUS: {
        official_name_en: 'Russian Federation',
        iso3166alpha2: 'RU',
        iso3166alpha3: 'RUS',
        cldr_display_name: 'Russia',
        capital: 'Moscow',
        continent: 'EU',
        dial: '7',
        geoname_id: '2017370',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '151',
        subregion_name: 'Eastern Europe',
        is_independent: 'Yes'
    },
    RWA: {
        official_name_en: 'Rwanda',
        iso3166alpha2: 'RW',
        iso3166alpha3: 'RWA',
        cldr_display_name: 'Rwanda',
        capital: 'Kigali',
        continent: 'AF',
        dial: '250',
        geoname_id: '49518',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    REU: {
        official_name_en: 'Réunion',
        iso3166alpha2: 'RE',
        iso3166alpha3: 'REU',
        cldr_display_name: 'Réunion',
        capital: 'Saint-Denis',
        continent: 'AF',
        dial: '262',
        geoname_id: '935317',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Part of FR'
    },
    BLM: {
        official_name_en: 'Saint Barthélemy',
        iso3166alpha2: 'BL',
        iso3166alpha3: 'BLM',
        cldr_display_name: 'Saint Barthélemy',
        capital: 'Gustavia',
        continent: 'NA',
        dial: '590',
        geoname_id: '3578476',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Part of FR'
    },
    SHN: {
        official_name_en: 'Saint Helena',
        iso3166alpha2: 'SH',
        iso3166alpha3: 'SHN',
        cldr_display_name: 'St. Helena',
        capital: 'Jamestown',
        continent: 'AF',
        dial: '290',
        geoname_id: '3370751',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Territory of GB'
    },
    KNA: {
        official_name_en: 'Saint Kitts and Nevis',
        iso3166alpha2: 'KN',
        iso3166alpha3: 'KNA',
        cldr_display_name: 'St. Kitts & Nevis',
        capital: 'Basseterre',
        continent: 'NA',
        dial: '1-869',
        geoname_id: '3575174',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    LCA: {
        official_name_en: 'Saint Lucia',
        iso3166alpha2: 'LC',
        iso3166alpha3: 'LCA',
        cldr_display_name: 'St. Lucia',
        capital: 'Castries',
        continent: 'NA',
        dial: '1-758',
        geoname_id: '3576468',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    MAF: {
        official_name_en: 'Saint Martin (French Part)',
        iso3166alpha2: 'MF',
        iso3166alpha3: 'MAF',
        cldr_display_name: 'St. Martin',
        capital: 'Marigot',
        continent: 'NA',
        dial: '590',
        geoname_id: '3578421',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Part of FR'
    },
    SPM: {
        official_name_en: 'Saint Pierre and Miquelon',
        iso3166alpha2: 'PM',
        iso3166alpha3: 'SPM',
        cldr_display_name: 'St. Pierre & Miquelon',
        capital: 'Saint-Pierre',
        continent: 'NA',
        dial: '508',
        geoname_id: '3424932',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '21',
        subregion_name: 'Northern America',
        is_independent: 'Part of FR'
    },
    VCT: {
        official_name_en: 'Saint Vincent and the Grenadines',
        iso3166alpha2: 'VC',
        iso3166alpha3: 'VCT',
        cldr_display_name: 'St. Vincent & Grenadines',
        capital: 'Kingstown',
        continent: 'NA',
        dial: '1-784',
        geoname_id: '3577815',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    WSM: {
        official_name_en: 'Samoa',
        iso3166alpha2: 'WS',
        iso3166alpha3: 'WSM',
        cldr_display_name: 'Samoa',
        capital: 'Apia',
        continent: 'OC',
        dial: '685',
        geoname_id: '4034894',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '61',
        subregion_name: 'Polynesia',
        is_independent: 'Yes'
    },
    SMR: {
        official_name_en: 'San Marino',
        iso3166alpha2: 'SM',
        iso3166alpha3: 'SMR',
        cldr_display_name: 'San Marino',
        capital: 'San Marino',
        continent: 'EU',
        dial: '378',
        geoname_id: '3168068',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '39',
        subregion_name: 'Southern Europe',
        is_independent: 'Yes'
    },
    STP: {
        official_name_en: 'Sao Tome and Principe',
        iso3166alpha2: 'ST',
        iso3166alpha3: 'STP',
        cldr_display_name: 'São Tomé and Príncipe',
        capital: 'Sao Tome',
        continent: 'AF',
        dial: '239',
        geoname_id: '2410758',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    '': {
        official_name_en: 'Sark',
        iso3166alpha2: 'CQ',
        iso3166alpha3: 'CRQ',
        cldr_display_name: 'Sark',
        capital: '',
        continent: '',
        dial: '',
        geoname_id: '',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '154',
        subregion_name: 'Northern Europe',
        is_independent: ''
    },
    SAU: {
        official_name_en: 'Saudi Arabia',
        iso3166alpha2: 'SA',
        iso3166alpha3: 'SAU',
        cldr_display_name: 'Saudi Arabia',
        capital: 'Riyadh',
        continent: 'AS',
        dial: '966',
        geoname_id: '102358',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '145',
        subregion_name: 'Western Asia',
        is_independent: 'Yes'
    },
    SEN: {
        official_name_en: 'Senegal',
        iso3166alpha2: 'SN',
        iso3166alpha3: 'SEN',
        cldr_display_name: 'Senegal',
        capital: 'Dakar',
        continent: 'AF',
        dial: '221',
        geoname_id: '2245662',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    SRB: {
        official_name_en: 'Serbia',
        iso3166alpha2: 'RS',
        iso3166alpha3: 'SRB',
        cldr_display_name: 'Serbia',
        capital: 'Belgrade',
        continent: 'EU',
        dial: '381',
        geoname_id: '6290252',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '39',
        subregion_name: 'Southern Europe',
        is_independent: 'Yes'
    },
    SYC: {
        official_name_en: 'Seychelles',
        iso3166alpha2: 'SC',
        iso3166alpha3: 'SYC',
        cldr_display_name: 'Seychelles',
        capital: 'Victoria',
        continent: 'AF',
        dial: '248',
        geoname_id: '241170',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    SLE: {
        official_name_en: 'Sierra Leone',
        iso3166alpha2: 'SL',
        iso3166alpha3: 'SLE',
        cldr_display_name: 'Sierra Leone',
        capital: 'Freetown',
        continent: 'AF',
        dial: '232',
        geoname_id: '2403846',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    SGP: {
        official_name_en: 'Singapore',
        iso3166alpha2: 'SG',
        iso3166alpha3: 'SGP',
        cldr_display_name: 'Singapore',
        capital: 'Singapore',
        continent: 'AS',
        dial: '65',
        geoname_id: '1880251',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '35',
        subregion_name: 'South-eastern Asia',
        is_independent: 'Yes'
    },
    SXM: {
        official_name_en: 'Sint Maarten (Dutch part)',
        iso3166alpha2: 'SX',
        iso3166alpha3: 'SXM',
        cldr_display_name: 'Sint Maarten',
        capital: 'Philipsburg',
        continent: 'NA',
        dial: '1-721',
        geoname_id: '7609695',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Part of NL'
    },
    SVK: {
        official_name_en: 'Slovakia',
        iso3166alpha2: 'SK',
        iso3166alpha3: 'SVK',
        cldr_display_name: 'Slovakia',
        capital: 'Bratislava',
        continent: 'EU',
        dial: '421',
        geoname_id: '3057568',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '151',
        subregion_name: 'Eastern Europe',
        is_independent: 'Yes'
    },
    SVN: {
        official_name_en: 'Slovenia',
        iso3166alpha2: 'SI',
        iso3166alpha3: 'SVN',
        cldr_display_name: 'Slovenia',
        capital: 'Ljubljana',
        continent: 'EU',
        dial: '386',
        geoname_id: '3190538',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '39',
        subregion_name: 'Southern Europe',
        is_independent: 'Yes'
    },
    SLB: {
        official_name_en: 'Solomon Islands',
        iso3166alpha2: 'SB',
        iso3166alpha3: 'SLB',
        cldr_display_name: 'Solomon Islands',
        capital: 'Honiara',
        continent: 'OC',
        dial: '677',
        geoname_id: '2103350',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '54',
        subregion_name: 'Melanesia',
        is_independent: 'Yes'
    },
    SOM: {
        official_name_en: 'Somalia',
        iso3166alpha2: 'SO',
        iso3166alpha3: 'SOM',
        cldr_display_name: 'Somalia',
        capital: 'Mogadishu',
        continent: 'AF',
        dial: '252',
        geoname_id: '51537',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    ZAF: {
        official_name_en: 'South Africa',
        iso3166alpha2: 'ZA',
        iso3166alpha3: 'ZAF',
        cldr_display_name: 'South Africa',
        capital: 'Pretoria',
        continent: 'AF',
        dial: '27',
        geoname_id: '953987',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    SGS: {
        official_name_en: 'South Georgia and the South Sandwich Islands',
        iso3166alpha2: 'GS',
        iso3166alpha3: 'SGS',
        cldr_display_name: 'South Georgia & South Sandwich Islands',
        capital: 'Grytviken',
        continent: 'AN',
        dial: '500',
        geoname_id: '3474415',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Territory of GB'
    },
    SSD: {
        official_name_en: 'South Sudan',
        iso3166alpha2: 'SS',
        iso3166alpha3: 'SSD',
        cldr_display_name: 'South Sudan',
        capital: 'Juba',
        continent: 'AF',
        dial: '211',
        geoname_id: '7909807',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    ESP: {
        official_name_en: 'Spain',
        iso3166alpha2: 'ES',
        iso3166alpha3: 'ESP',
        cldr_display_name: 'Spain',
        capital: 'Madrid',
        continent: 'EU',
        dial: '34',
        geoname_id: '2510769',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '39',
        subregion_name: 'Southern Europe',
        is_independent: 'Yes'
    },
    LKA: {
        official_name_en: 'Sri Lanka',
        iso3166alpha2: 'LK',
        iso3166alpha3: 'LKA',
        cldr_display_name: 'Sri Lanka',
        oldCountryName: 'SriLanka',
        capital: 'Colombo',
        continent: 'AS',
        dial: '94',
        geoname_id: '1227603',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '34',
        subregion_name: 'Southern Asia',
        is_independent: 'Yes'
    },
    PSE: {
        official_name_en: 'State of Palestine',
        iso3166alpha2: 'PS',
        iso3166alpha3: 'PSE',
        cldr_display_name: 'Palestine',
        capital: 'East Jerusalem',
        continent: 'AS',
        dial: '970',
        geoname_id: '6254930',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '145',
        subregion_name: 'Western Asia',
        is_independent: 'In contention'
    },
    SDN: {
        official_name_en: 'Sudan',
        iso3166alpha2: 'SD',
        iso3166alpha3: 'SDN',
        cldr_display_name: 'Sudan',
        capital: 'Khartoum',
        continent: 'AF',
        dial: '249',
        geoname_id: '366755',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '15',
        subregion_name: 'Northern Africa',
        is_independent: 'Yes'
    },
    SUR: {
        official_name_en: 'Suriname',
        iso3166alpha2: 'SR',
        iso3166alpha3: 'SUR',
        cldr_display_name: 'Suriname',
        capital: 'Paramaribo',
        continent: 'SA',
        dial: '597',
        geoname_id: '3382998',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    SJM: {
        official_name_en: 'Svalbard and Jan Mayen Islands',
        iso3166alpha2: 'SJ',
        iso3166alpha3: 'SJM',
        cldr_display_name: 'Svalbard & Jan Mayen',
        oldCountryName: 'Svalbard and Jan Mayen',
        capital: 'Longyearbyen',
        continent: 'EU',
        dial: '47',
        geoname_id: '607072',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '154',
        subregion_name: 'Northern Europe',
        is_independent: 'Territory of NO'
    },
    SWZ: {
        official_name_en: 'Swaziland',
        iso3166alpha2: 'SZ',
        iso3166alpha3: 'SWZ',
        cldr_display_name: 'Swaziland',
        capital: 'Mbabane',
        continent: 'AF',
        dial: '268',
        geoname_id: '934841',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    SWE: {
        official_name_en: 'Sweden',
        iso3166alpha2: 'SE',
        iso3166alpha3: 'SWE',
        cldr_display_name: 'Sweden',
        capital: 'Stockholm',
        continent: 'EU',
        dial: '46',
        geoname_id: '2661886',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '154',
        subregion_name: 'Northern Europe',
        is_independent: 'Yes'
    },
    CHE: {
        official_name_en: 'Switzerland',
        iso3166alpha2: 'CH',
        iso3166alpha3: 'CHE',
        cldr_display_name: 'Switzerland',
        capital: 'Bern',
        continent: 'EU',
        dial: '41',
        geoname_id: '2658434',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '155',
        subregion_name: 'Western Europe',
        is_independent: 'Yes'
    },
    SYR: {
        official_name_en: 'Syrian Arab Republic',
        iso3166alpha2: 'SY',
        iso3166alpha3: 'SYR',
        cldr_display_name: 'Syria',
        capital: 'Damascus',
        continent: 'AS',
        dial: '963',
        geoname_id: '163843',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '145',
        subregion_name: 'Western Asia',
        is_independent: 'Yes'
    },
    TJK: {
        official_name_en: 'Tajikistan',
        iso3166alpha2: 'TJ',
        iso3166alpha3: 'TJK',
        cldr_display_name: 'Tajikistan',
        capital: 'Dushanbe',
        continent: 'AS',
        dial: '992',
        geoname_id: '1220409',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '143',
        subregion_name: 'Central Asia',
        is_independent: 'Yes'
    },
    THA: {
        official_name_en: 'Thailand',
        iso3166alpha2: 'TH',
        iso3166alpha3: 'THA',
        cldr_display_name: 'Thailand',
        capital: 'Bangkok',
        continent: 'AS',
        dial: '66',
        geoname_id: '1605651',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '35',
        subregion_name: 'South-eastern Asia',
        is_independent: 'Yes'
    },
    MKD: {
        official_name_en: 'The former Yugoslav Republic of Macedonia',
        iso3166alpha2: 'MK',
        iso3166alpha3: 'MKD',
        cldr_display_name: 'Macedonia',
        capital: 'Skopje',
        continent: 'EU',
        dial: '389',
        geoname_id: '718075',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '39',
        subregion_name: 'Southern Europe',
        is_independent: 'Yes'
    },
    TLS: {
        official_name_en: 'Timor-Leste',
        iso3166alpha2: 'TL',
        iso3166alpha3: 'TLS',
        cldr_display_name: 'Timor-Leste',
        oldCountryName: 'East Timor',
        capital: 'Dili',
        continent: 'OC',
        dial: '670',
        geoname_id: '1966436',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '35',
        subregion_name: 'South-eastern Asia',
        is_independent: 'Yes'
    },
    TGO: {
        official_name_en: 'Togo',
        iso3166alpha2: 'TG',
        iso3166alpha3: 'TGO',
        cldr_display_name: 'Togo',
        capital: 'Lome',
        continent: 'AF',
        dial: '228',
        geoname_id: '2363686',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    TKL: {
        official_name_en: 'Tokelau',
        iso3166alpha2: 'TK',
        iso3166alpha3: 'TKL',
        cldr_display_name: 'Tokelau',
        capital: '',
        continent: 'OC',
        dial: '690',
        geoname_id: '4031074',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '61',
        subregion_name: 'Polynesia',
        is_independent: 'Territory of NZ'
    },
    TON: {
        official_name_en: 'Tonga',
        iso3166alpha2: 'TO',
        iso3166alpha3: 'TON',
        cldr_display_name: 'Tonga',
        capital: "Nuku'alofa",
        continent: 'OC',
        dial: '676',
        geoname_id: '4032283',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '61',
        subregion_name: 'Polynesia',
        is_independent: 'Yes'
    },
    TTO: {
        official_name_en: 'Trinidad and Tobago',
        iso3166alpha2: 'TT',
        iso3166alpha3: 'TTO',
        cldr_display_name: 'Trinidad & Tobago',
        capital: 'Port of Spain',
        continent: 'NA',
        dial: '1-868',
        geoname_id: '3573591',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    TUN: {
        official_name_en: 'Tunisia',
        iso3166alpha2: 'TN',
        iso3166alpha3: 'TUN',
        cldr_display_name: 'Tunisia',
        capital: 'Tunis',
        continent: 'AF',
        dial: '216',
        geoname_id: '2464461',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '15',
        subregion_name: 'Northern Africa',
        is_independent: 'Yes'
    },
    TUR: {
        official_name_en: 'Turkey',
        iso3166alpha2: 'TR',
        iso3166alpha3: 'TUR',
        cldr_display_name: 'Turkey',
        capital: 'Ankara',
        continent: 'AS',
        dial: '90',
        geoname_id: '298795',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '145',
        subregion_name: 'Western Asia',
        is_independent: 'Yes'
    },
    TKM: {
        official_name_en: 'Turkmenistan',
        iso3166alpha2: 'TM',
        iso3166alpha3: 'TKM',
        cldr_display_name: 'Turkmenistan',
        capital: 'Ashgabat',
        continent: 'AS',
        dial: '993',
        geoname_id: '1218197',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '143',
        subregion_name: 'Central Asia',
        is_independent: 'Yes'
    },
    TCA: {
        official_name_en: 'Turks and Caicos Islands',
        iso3166alpha2: 'TC',
        iso3166alpha3: 'TCA',
        cldr_display_name: 'Turks & Caicos Islands',
        capital: 'Cockburn Town',
        continent: 'NA',
        dial: '1-649',
        geoname_id: '3576916',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Territory of GB'
    },
    TUV: {
        official_name_en: 'Tuvalu',
        iso3166alpha2: 'TV',
        iso3166alpha3: 'TUV',
        cldr_display_name: 'Tuvalu',
        capital: 'Funafuti',
        continent: 'OC',
        dial: '688',
        geoname_id: '2110297',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '61',
        subregion_name: 'Polynesia',
        is_independent: 'Yes'
    },
    UGA: {
        official_name_en: 'Uganda',
        iso3166alpha2: 'UG',
        iso3166alpha3: 'UGA',
        cldr_display_name: 'Uganda',
        capital: 'Kampala',
        continent: 'AF',
        dial: '256',
        geoname_id: '226074',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    UKR: {
        official_name_en: 'Ukraine',
        iso3166alpha2: 'UA',
        iso3166alpha3: 'UKR',
        cldr_display_name: 'Ukraine',
        capital: 'Kiev',
        continent: 'EU',
        dial: '380',
        geoname_id: '690791',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '151',
        subregion_name: 'Eastern Europe',
        is_independent: 'Yes'
    },
    ARE: {
        official_name_en: 'United Arab Emirates',
        iso3166alpha2: 'AE',
        iso3166alpha3: 'ARE',
        cldr_display_name: 'United Arab Emirates',
        capital: 'Abu Dhabi',
        continent: 'AS',
        dial: '971',
        geoname_id: '290557',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '145',
        subregion_name: 'Western Asia',
        is_independent: 'Yes'
    },
    GBR: {
        official_name_en: 'United Kingdom of Great Britain and Northern Ireland',
        iso3166alpha2: 'GB',
        iso3166alpha3: 'GBR',
        cldr_display_name: 'UK',
        oldCountryName: 'United Kingdom',
        capital: 'London',
        continent: 'EU',
        dial: '44',
        geoname_id: '2635167',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '154',
        subregion_name: 'Northern Europe',
        is_independent: 'Yes'
    },
    TZA: {
        official_name_en: 'United Republic of Tanzania',
        iso3166alpha2: 'TZ',
        iso3166alpha3: 'TZA',
        cldr_display_name: 'Tanzania',
        capital: 'Dodoma',
        continent: 'AF',
        dial: '255',
        geoname_id: '149590',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    UMI: {
        official_name_en: 'United States Minor Outlying Islands',
        iso3166alpha2: 'UM',
        iso3166alpha3: 'UMI',
        cldr_display_name: 'U.S. Outlying Islands',
        capital: '',
        continent: 'OC',
        dial: '',
        geoname_id: '5854968',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '57',
        subregion_name: 'Micronesia',
        is_independent: 'Territories of US'
    },
    VIR: {
        official_name_en: 'United States Virgin Islands',
        iso3166alpha2: 'VI',
        iso3166alpha3: 'VIR',
        cldr_display_name: 'U.S. Virgin Islands',
        oldCountryName: 'Virgin Islands, U.S.',
        capital: 'Charlotte Amalie',
        continent: 'NA',
        dial: '1-340',
        geoname_id: '4796775',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Territory of US'
    },
    USA: {
        official_name_en: 'United States of America',
        iso3166alpha2: 'US',
        iso3166alpha3: 'USA',
        cldr_display_name: 'US',
        oldCountryName: 'United States',
        capital: 'Washington',
        continent: 'NA',
        dial: '1',
        geoname_id: '6252001',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '21',
        subregion_name: 'Northern America',
        is_independent: 'Yes'
    },
    URY: {
        official_name_en: 'Uruguay',
        iso3166alpha2: 'UY',
        iso3166alpha3: 'URY',
        cldr_display_name: 'Uruguay',
        capital: 'Montevideo',
        continent: 'SA',
        dial: '598',
        geoname_id: '3439705',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    UZB: {
        official_name_en: 'Uzbekistan',
        iso3166alpha2: 'UZ',
        iso3166alpha3: 'UZB',
        cldr_display_name: 'Uzbekistan',
        capital: 'Tashkent',
        continent: 'AS',
        dial: '998',
        geoname_id: '1512440',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '143',
        subregion_name: 'Central Asia',
        is_independent: 'Yes'
    },
    VUT: {
        official_name_en: 'Vanuatu',
        iso3166alpha2: 'VU',
        iso3166alpha3: 'VUT',
        cldr_display_name: 'Vanuatu',
        capital: 'Port Vila',
        continent: 'OC',
        dial: '678',
        geoname_id: '2134431',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '54',
        subregion_name: 'Melanesia',
        is_independent: 'Yes'
    },
    VEN: {
        official_name_en: 'Venezuela (Bolivarian Republic of)',
        iso3166alpha2: 'VE',
        iso3166alpha3: 'VEN',
        cldr_display_name: 'Venezuela',
        capital: 'Caracas',
        continent: 'SA',
        dial: '58',
        geoname_id: '3625428',
        global_code: 'True',
        global_name: 'World',
        region_code: '19',
        region_name: 'Americas',
        subregion_code: '419',
        subregion_name: 'Latin America and the Caribbean',
        is_independent: 'Yes'
    },
    VNM: {
        official_name_en: 'Viet Nam',
        iso3166alpha2: 'VN',
        iso3166alpha3: 'VNM',
        cldr_display_name: 'Vietnam',
        capital: 'Hanoi',
        continent: 'AS',
        dial: '84',
        geoname_id: '1562822',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '35',
        subregion_name: 'South-eastern Asia',
        is_independent: 'Yes'
    },
    WLF: {
        official_name_en: 'Wallis and Futuna Islands',
        iso3166alpha2: 'WF',
        iso3166alpha3: 'WLF',
        cldr_display_name: 'Wallis & Futuna',
        oldCountryName: 'Wallis and Futuna',
        capital: 'Mata Utu',
        continent: 'OC',
        dial: '681',
        geoname_id: '4034749',
        global_code: 'True',
        global_name: 'World',
        region_code: '9',
        region_name: 'Oceania',
        subregion_code: '61',
        subregion_name: 'Polynesia',
        is_independent: 'Territory of FR'
    },
    ESH: {
        official_name_en: 'Western Sahara',
        iso3166alpha2: 'EH',
        iso3166alpha3: 'ESH',
        cldr_display_name: 'Western Sahara',
        capital: 'El-Aaiun',
        continent: 'AF',
        dial: '212',
        geoname_id: '2461445',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '15',
        subregion_name: 'Northern Africa',
        is_independent: 'In contention'
    },
    YEM: {
        official_name_en: 'Yemen',
        iso3166alpha2: 'YE',
        iso3166alpha3: 'YEM',
        cldr_display_name: 'Yemen',
        capital: 'Sanaa',
        continent: 'AS',
        dial: '967',
        geoname_id: '69543',
        global_code: 'True',
        global_name: 'World',
        region_code: '142',
        region_name: 'Asia',
        subregion_code: '145',
        subregion_name: 'Western Asia',
        is_independent: 'Yes'
    },
    ZMB: {
        official_name_en: 'Zambia',
        iso3166alpha2: 'ZM',
        iso3166alpha3: 'ZMB',
        cldr_display_name: 'Zambia',
        capital: 'Lusaka',
        continent: 'AF',
        dial: '260',
        geoname_id: '895949',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    ZWE: {
        official_name_en: 'Zimbabwe',
        iso3166alpha2: 'ZW',
        iso3166alpha3: 'ZWE',
        cldr_display_name: 'Zimbabwe',
        capital: 'Harare',
        continent: 'AF',
        dial: '263',
        geoname_id: '878675',
        global_code: 'True',
        global_name: 'World',
        region_code: '2',
        region_name: 'Africa',
        subregion_code: '202',
        subregion_name: 'Sub-Saharan Africa',
        is_independent: 'Yes'
    },
    ALA: {
        official_name_en: 'Åland Islands',
        iso3166alpha2: 'AX',
        iso3166alpha3: 'ALA',
        cldr_display_name: 'Åland Islands',
        capital: 'Mariehamn',
        continent: 'EU',
        dial: '358',
        geoname_id: '661882',
        global_code: 'True',
        global_name: 'World',
        region_code: '150',
        region_name: 'Europe',
        subregion_code: '154',
        subregion_name: 'Northern Europe',
        is_independent: 'Part of FI'
    }
};
